import script from "./DiagnosticICD10CodeAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticICD10CodeAutocomplete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__